module.exports = __webpack_public_path__ + "img/check-circle.df42de6d.svg";